
import { message } from "ant-design-vue";
import { RuleObject } from "ant-design-vue/lib/form";

/**
 * 
 * @description 对合并行的处理
 * @param {String} key 需要合并列的key
 * @param {Array} data 表格数据
 * @param return Array
 */
export function rowSpanFun(key: string, data: any[]) {
  const arr = data
    .reduce((result, item) => {
      if (result.indexOf(item[key]) < 0) {
        result.push(item[key]);
      }
      return result;
    }, [])
    .reduce((result: any[], keys: any) => {
      const children = data.filter((item) => item[key] === keys);
      result = result.concat(
        children.map((item, index) => ({
          ...item,
          [`RowSpan`]: index === 0 ? children.length : 0,
        }))
      );
      return result;
    }, []);
  return arr;
}

/**
 * 
 * @description 邮箱校验
 */
export const emailValidate = (rule: RuleObject, value: string) => {
  if (value === '') {
    return Promise.reject('请输入邮箱');
  }
  if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('邮箱格式不正确');
}
/**
 * 
 * @description 手机校验
 */
export const phoneValidate = (rule: RuleObject, value: string) => {
  if (value === '') {
    return Promise.reject('请输入手机号');
  }
  if (/^1[23456789]\d{9}$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('请输入正确的手机号');
}
/**
 * 
 * @description 密码校验
 */
export const passwordValidate = (rule: RuleObject, value: string) => {
  if (value === '') {
    return Promise.reject('请输入密码');
  }
  if(value.length >=8 && /^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('密码需要包含数字和字母且长度大于等于8位');
}

/**
 * 
 * @description 序列校验
 */
 export const sequenceValidate = (rule: RuleObject, value: string) => {
  const reg = /^(a|t|c|g)*$/i
  if (value === '') {
    return Promise.resolve();
  }
  if(reg.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('请输入atcg');
}

// 深拷贝
export function deepClone(source: any) {
  if (!source || typeof source !== 'object') {
    return source
    // throw new Error('error arguments', 'shallowClone')
  }
  const targetObj:any = Array.isArray(source) ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * json数组去重
 * @param {Array} array 需要去重的数组
 * @param {String} key  根据key字段去重
 */
 
 export function uniqueArray(array: Array<any>, key: string) {
  const result = [array[0]]
  for (let i = 1; i < array.length; i++) {
    const item = array[i]
    let repeat = false
      for (let j = 0; j < result.length; j++) {
          if (item[key] === result[j][key]) {
              repeat = true
              break
          }
      }
      if (!repeat) {
          result.push(item);
      }
  }
  return result
}
export const getRemoveBlankLines = <T>(data: T[]) => {
  const arr: T[] = []
  data.forEach(el => {
    let _flag = false
    for (const key in el) {
      // 当前key存在值
      if(el[key]) {
        _flag = true
      }
    }
    // 当前key存在值 跳出循环 存入数组
    if(_flag) {
      arr.push(el)
    }
  });
  return arr
}
/**
 * 重复校验
 * @param {Array} array 
 * @param {String} key  根据key字段查重
 */
export const repeatValidator = (data: any[], key: string) => {
  // 校验基因名称是否重复
  let _flag = true
  const arr =  data.map((item: any) => item[key]) // 所有key 的集合
  const arrSet = Array.from(new Set(arr)) // 去掉重复的数据
  if(arrSet.length < arr.length) {
    if(key === 'genename') {
      message.error('基因名称不能重复');
    } else if(key === 'sequence_des') {
      message.error('序列不能重复');
    }
    _flag = false
  } else {
    _flag = true
  }
  return _flag
}
// 
export const sequenceDesValidator = (value: any, callback: any) => {
  const reg = /^[a-z*]+$/i
  if(!value) {
    callback(false)
    return
  }
  if(!reg.test(value)) {
    callback(false)
    return
  }
  callback(true)
}
// 校验序列
export const sequenceValidator = (value: any, callback: any) => {
  const reg = /^[a-z*]+$/i
  if(!value) {
    callback(true)
    return
  }
  if(!reg.test(value)) {
    callback(false)
    return
  }
  callback(true)
}
// 序列展示转换
export const showTextSequence = (value: string) => {
  let htmlStr = ''
  let int = value.toUpperCase() 
  while (int.length > 10) {
    htmlStr = htmlStr + ',' + int.slice(0,10)
    int = int.length > 10 ? int.slice(10,int.length) : int.slice(0,10)
    if(int.length <= 10) {
      htmlStr = htmlStr + ',' + int.slice(0,10)
    }
  }
  if(value.length <= 10) {
    htmlStr = value.toUpperCase() 
  }
  htmlStr = htmlStr.includes(',') ? htmlStr.slice(1, htmlStr.length) : htmlStr
  const htmlStrArr = htmlStr.split(',') // 转换数组后进行分行拆分
  let result = '' // 保存最终字符串
  let num = 0
  htmlStrArr.forEach((el: string, index: number) => {
    if (index === 0) {
      num++
      result = `<span style="display: inline-block;width: 80px;">${num}</span>` + '&nbsp;&nbsp;' + el
    } else if (index !== 0 && index%4==0) { // 4的倍数可以拆分到下一行
      num++
      result = result + '</br>' + `<span style="display: inline-block;width: 80px;">${num}</span>` + '&nbsp;&nbsp;' + el
    } else {
      result = result + '&nbsp;&nbsp;' + el
    }
  });
  return result
}

/**
 * 导出文件
 * @param blob 文件Blob
 * @param name 文件名
 * @param suffix 文件后缀 默认.xlsx
 */
export function exportFile(blob: Blob,name: string, suffix = '.xlsx') {
  return new Promise<void>((resolve, reject) => {
    try {
      console.log(blob)
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = url
      link.download = name + suffix;
      link.click()
      URL.revokeObjectURL(url)
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}
// 是否是纯数值
export const numReturn = (value: any) => {
  const reg = /^(-)?[0-9]+([.][0-9]{1,})?$/
  if (!reg.test(value)) return false
  return true
}

//处理值是值不为数值直接返回 否则处理数值
export function handleNumber(value: any, mantissa = 2) {
  const reg = /^(-)?[0-9]+([.][0-9]{1,})?$/
  if (!reg.test(value)) {
    return value
  }
  if (typeof value == "string") {
    value = Number(value);
  }
  if (!value) {
    value = 0
  }
  value = value.toFixed(mantissa);
  return value
}
// 获取url参数
export function queryURLParams(url: string) {
  const urlStr = url.split("?")[1];
  if(!urlStr) return {}
  const obj:any = {}; // 声明参数对象
  const arr = urlStr.split("&"); // 以&符号分割为数组
  for (let i = 0; i < arr.length; i++) {
    const arrNew = arr[i].split("="); // 以"="分割为数组
    obj[arrNew[0]] = arrNew[1];
  }
  return obj;
}